// @flow
import React from 'react';
import type { Node } from 'react';
import styled, { type StyledComponent } from 'styled-components';

import classNames from 'classnames';

import type { CommonProps } from './FormGroup.types';

export const Wrapper: StyledComponent<{}> = styled.div`
  position: relative;
`;

export type Props = {
  ...CommonProps,
  className: string,
  errorDirection: ?string,
};
export const FormGroup = ({ className, children, ...other }: Props): Node => (
  <Wrapper className={classNames(className, 'form-group')} {...other}>
    {children}
  </Wrapper>
);

FormGroup.defaultProps = {
  className: '',
  validationError: '',
  errorDirection: 'top',
};

export default FormGroup;



// WEBPACK FOOTER //
// ../react-lib/src/components/formFields/FormGroup/FormGroup.jsx